import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { RoomState } from './types';
import { RootState } from '../../types';
import { state } from './state';

const namespaced: boolean = true;

export const roomModule: Module<RoomState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
